module.exports = __webpack_public_path__ + "assets/79022ddfba7d526c927b7a088bfec050.mp3";